// extracted by mini-css-extract-plugin
export default {"Loader-wrapper":"loader_Loader-wrapper__orMcJ","loader":"loader_loader__r9oBd","Table":"loader_Table__z38-q"};